import { Component, OnInit } from '@angular/core';
import { NeveMeasurementsService } from '../measurements/neve-measurements.service';
import { default as getTenantConfig } from '~app/shared/map/layer/layer-definitions/T14';

@Component({
  selector: 'qm-neve-base',
  templateUrl: './neve-base.component.html'
})
export class NeveBaseComponent implements OnInit {
  constructor(
    private readonly measurements: NeveMeasurementsService
    ) {
  }

  ngOnInit() {
    // ensures tags will get loaded in the background even if measurement table components are not open
    this.measurements.init(getTenantConfig().tenantCustomData.valmetDnaTags.power.allNetworks.map(config => config.tagpair));
  }
}
